"use client";

import * as React from "react";

import { BREAKPOINTS, belowQuery } from "@tami/tokens";

const MOBILE_MEDIA_QUERY = belowQuery(BREAKPOINTS.compactLayout);

const getIsMobileSnapshot = (): boolean => {
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

const subscribeToMobileMediaQuery = (onStoreChange: () => void): (() => void) => {
  const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
  mediaQueryList.addEventListener("change", onStoreChange);
  return () => mediaQueryList.removeEventListener("change", onStoreChange);
};

export function useIsMobile(): boolean {
  return React.useSyncExternalStore(
    subscribeToMobileMediaQuery,
    getIsMobileSnapshot,
    () => false,
  );
}
